import React, { forwardRef, useState } from "react";
import classnames from "classnames";
import Input from "../Input";
import styled from "styled-components";
import { validate } from "../../../utilities/formValidators";
import { INPUT_TYPE } from "../../../utilities/validatorConstants";
import IBuildrProps from "../../../utilities/IBuildrProps";

export interface ITextAreaProps extends IBuildrProps {
    value: string;
    id: number | string;
    onChange: any;
    label?: string;
    required?: boolean;
    placeholder?: string;
    textAreaClassName?: string;
    textContainerClassName?: string
}

const TextArea = styled(forwardRef((props: ITextAreaProps, ref: any) => {
    const { value, textContainerClassName = "my-4", id, onChange, label = '', required, className, cmsId, editorClassObj, placeholder, textAreaClassName = "mb-2" } = props;
    const [error, setError] = useState(null);

    const inputProps = {
        className,
        hasValue: value.length > 0,
        error,
        id,
        label
    };

    function handleBlur(event) {
        if (validate(event.target.value, INPUT_TYPE.TEXT)) {
            setError("");
            onChange(event);
        } else {
            if (required) {
                setError(`${label} is required`);
            }
        }
    }

    return (
        <div data-id={cmsId} ref={ref} className={classnames("w-100", textContainerClassName, editorClassObj)}>
            <Input
                {...inputProps} >
                <textarea
                    name={String(id)}
                    placeholder={placeholder}
                    value={value}
                    onChange={onChange}
                    onBlur={handleBlur}
                    className={classnames(textAreaClassName, "form-control", "pt-3", "px-3", { "has-label": label })}
                    autoComplete="off"
                ></textarea>
            </Input>
        </div>

    );
}))`

textarea.has-label {
    padding-top: 1.4rem !important;
}

textarea:focus+label, .has-value label {
    font-size: 12px;
    padding-top: .1rem;
    padding-left: .5rem;
}
`;

export default TextArea;
(global as any).TextArea = TextArea;